var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JsonContent',{attrs:{"json-item":_vm.admin_node_raw}})
}
var staticRenderFns = []

export { render, staticRenderFns }